export default __webpack_public_path__ + "static/media/payout-image.efa2095e.png";